<template>
    <shadow-badged-image :src="e.thumbnail"
                         :lazy="true"
                         fit="cover"
                         @click.native="clickHandler(e.shortcode)">
        <!-- 使用具名 slot 填充 placeholder 用于展示图片加载（loading）过程 -->
        <div slot="placeholder">
            <!--
            备注，这类是添加分页加载时候的等待特效。目前经过两个版本，V1 是加载一个 spinner，V2 是加载一个灰色的透明图片，为了样式统一，使用 el-image。
            -->
            <!-- 注意，要想让 iconfont 转动起来，必须在块元素 div 上添加 rotate 样式 -->
            <!-- <div class="iconfont icon-sy-loading rotate" style="font-size: 20px;"></div>-->
            <!-- 注意，该等待图片在 Chrome mobile screen 的尺寸下，在图片下会多 3px 的像素，但是在真机上不会，以真机为准 -->
            <el-image :src="require('@/assets/transparent-gray.png')" fit="cover"></el-image>
        </div>

        <!-- 如果是图集, fill the images badge slot -->
        <iconfont-selector v-if="isImageSet(e)"
                           slot="badge"
                           default-class="iconfont icon-sy-images"
                           default-color="#F2F6FC"
                           actived-class="iconfont icon-sy-images"
                           actived-color="#F2F6FC"
                           :font-size="23"
                           :line-height="25"
        />

        <!-- 如果是视频, fill the video badge slot -->
        <iconfont-selector v-if="e.is_video"
                           slot="badge"
                           default-class="iconfont icon-sy-video"
                           default-color="#F2F6FC"
                           actived-class="iconfont icon-sy-video"
                           actived-color="#F2F6FC"
                           :font-size="25"
                           :line-height="25"
        />

        <!-- fill the description slot -->
        <div slot="desc">
            <iconfont-selector style="padding-right: 12px"
                               default-color="#ffffff"
                               default-class="iconfont icon-sy-love-fill"
                               actived-color="#ffffff"
                               actived-class="iconfont icon-sy-love-fill"
                               :font-size="25"
                               :font-weight="600"
                               :line-height="25"
                               :text="e.likes_hrn"
                               :text-font-size="16"
                               :text-font-weight="600"
                               :zoomable="false"
            />
            <iconfont-selector style="padding-right: 12px"
                               default-color="#ffffff"
                               default-class="iconfont icon-sy-favorite-fill"
                               actived-color="#ffffff"
                               actived-class="iconfont icon-sy-favorite-fill"
                               :font-size="22"
                               :font-weight="600"
                               :line-height="25"
                               :text="e.favorites_hrn"
                               :text-font-size="16"
                               :text-font-weight="600"
                               :zoomable="false"
            />
        </div>
    </shadow-badged-image>
</template>

<script>
    import ShadowBadgedImage from "../commons/ShadowBadgedImage";

    export default {
        name: "ListCell",
        components: {ShadowBadgedImage},
        props: {
            e: Object, // entity
            isLast: Boolean,  // if not last, needs margin class
            clickHandler: Function  // the callback function how to show the entity image.
        },
        methods:{
            /**
             * 判断是否是图集
             * @param e
             * @return {Boolean}
             */
            isImageSet: function(e){
                return e.is_video == false && e.slots.length > 1;
            },

            click: function(e){
                // e.stopPropagation();
                // e.preventDefault();
                // e.handled = true;
                clickHandler(e.shortcode)
            }

        }
    }
</script>

<style scoped>
    .el-image {
        height: 100%;
        width: 100%;
        cursor: pointer;
        position: relative; /* 相当核心的一个配置，否则图片响应式布局出问题，图片高度会默认为屏幕的高度 */
        /*
           - fix HCF334 list page 中为什么等待图片之间会多出一道间距，发现默认的是 display: inline-block
             究其原因是因为块元素和行内元素的区别，块元素不但要占据整行并且还要要新起一行，因此造成了布局上的差异。
        */
        display: inline;
    }

    /* ===== .margin is defined in ListRow =====*/
    /*.margin {*/
    /*    margin-right: 3px;*/
    /*    margin-bottom: 3px;*/
    /*}*/

    /*!* @media 中的 .el-image-self 会覆盖前面的 .el-image-self *!*/
    /*@media (min-width: 736px) and (max-width: 974px) {*/
    /*    .margin {*/
    /*        margin-right: 28px;*/
    /*        margin-bottom: 28px;*/
    /*    }*/

    /*}*/

    /*@media (min-width: 975px) {*/
    /*    .margin {*/
    /*        margin-right: 28px;*/
    /*        margin-bottom: 28px;*/
    /*    }*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/list/ListCell.vue